import { useContext } from "react";
import { CartMiniContext } from "./CartMiniContext";
export const useCartMiniContext = () => {
    const context = useContext(CartMiniContext);
    if (!context) {
        throw new Error("useCartMiniContext used outside of CartMiniProvider");
    }
    return context;
};
//# sourceMappingURL=useCartMiniContext.js.map